import { CoachEvent } from '../../../backendsdk/api';

export interface SyntheticCoachSession {
    session_id: number;
    driver_name?: string;
    license_plate?: string;
    is_saved: boolean;
    sent: boolean;
    done: boolean;
    events: CoachEvent[];
}

export const DAILYDASHBOARD_MIXPANEL_SESSION = new Date().getTime();

export type FleetDriversView = 'vehicles' | 'drivers';
